import { ENavigator } from '../../navigator'

class Activated extends HTMLElement {
  public connectedCallback (): void {
    this.appendChild(
      <a-button-container>
        <a-button action={ ENavigator.Deactivate } icon="deactivate" key="activator.button.deactivate" />
        <a-button action={ ENavigator.Start } icon="start" key="activator.button.start" />
      </a-button-container>
    )
  }
}

customElements.define('a-activated', Activated)
